// project-imports
import icon from 'assets/images/icon.png';

// ==============================|| LOGO ICON (collapsed drawer) ||============================== //

// Used when the sidebar is collapsed. DrawerHeader caps the wrapper at 52px,
// so 44px renders the icon at a comfortable size without crowding the edges.
export default function LogoIcon() {
  return <img src={icon} alt="Vektra" height={44} width={44} style={{ display: 'block', objectFit: 'contain' }} />;
}
